import moment from 'moment'

const DATE_FORMAT = 'YYYY-MM-DD'

export function todayLocalDate () {
  return moment().format(DATE_FORMAT)
}
